<template>
  <li class="pic__item">
    <a href="javascript:;">
      <div class="pic__wrap">
        <div class="pic__head img__inner">
          <img class="img-resp"
            :src="item.src"
            :alt="item.feature">
        </div>
        <div class="pic__body">
          <h2 class="pic__brand">{{ item.brand }}</h2>
          <p class="pic__feature text-ellipsis">{{ item.feature }}</p>
          <p class="pic__desc">{{ item.desc }}</p>
        </div>
      </div>
    </a>
  </li>
</template>

<script>
export default {
  props: ['item'],
  name: 'PicItem',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.pic__item {
  float: left;
  width: 25%;
  padding: 1em;
}

.pic__brand, .pic__feature, .pic__desc {
  margin: 0;
  padding: 0;
}

.pic__desc {
  line-height: 1.5;
}

.pic a {
  text-decoration: none;
}

.pic-box .pic__wrap {
  position: relative;
}

.pic-box .pic__wrap::after {
  z-index: -1;
  position: absolute;
  bottom: -1em;
  left: 0;
  background-image: radial-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0) 60%);
  width: 100%;
  height: 2em;
  content: '';
}

.pic-box .pic__body {
  padding: 1em;
  background-color: #fff;
}

.pic-box .pic__brand {
  color: orange;
}

.pic-box .pic__feature {
  margin-top: 5px;
  margin-bottom: 5px;
  font-size: 1.2em;
  color: #333;
}

.pic-box .pic__desc {
  height: 45px;
  color: #999;
  overflow: hidden;
}

.pic-ovl .pic__wrap::after,
.pic-ovl .pic__body,
.pic-ovl .pic__brand,
.pic-ovl .img-resp {
  transition: all .5s ease;
}

.pic-ovl .pic__item:first-child {
  width: 50%;
}

.pic-ovl .pic__wrap {
  position: relative;
  overflow: hidden;
}

.pic-ovl .pic__wrap::after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, 0.7) 100%);
  content: '';
}

.pic-ovl .pic__wrap:hover .pic__body {
  bottom: 0;
}

.pic-ovl .pic__wrap:hover .pic__brand {
  color: orange;
}

.pic-ovl .pic__wrap:hover .img-resp {
  transform: scale(1.2);
}

.pic-ovl .pic__body {
  z-index: 1;
  position: absolute;
  bottom: -60px;
  left: 0;
  width: 100%;
  padding: 15px;
}

.pic-ovl .pic__brand {
  color: #ccc;
  font-style: italic;
}

.pic-ovl .pic__feature {
  margin-top: 5px;
  margin-bottom: 15px;
  font-size: 1.2em;
  color: #fff;
}

.pic-ovl .pic__desc {
  height: 45px;
  color: #fff;
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/PicItem.vue